<template lang="pug">
.dialog-container(v-if="show", @touchmove.prevent)
  .dialog-info
    .dialog-block
      .dialog-btn(@click="update")
    .dialog-close(@click="close")
      img(src="https://m.hellobike.com/resource/helloyun/08345/RgWuqOj-cJ.png")
  .shadow
</template>
<script>
import { updateCard } from '@/api/update-card.js';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import Toast from '@/components/toast';
import {
  getTokenAndLocation,
} from '@/utils';

export default {
  components: {
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    userNewId: {
      type: Number,
      default: 0,
    },
    businessId: {
      type: Number,
      default: 0,
    },
    beforeUserCardId: {
      type: String,
      required: true,
    },
    activeId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
    };
  },
  watch: {
  },
  mounted() {
  },
  destroyed() {
  },
  methods: {
    async update() {
      try {
        const { token } = await getTokenAndLocation();
        const res = await updateCard({
          token,
          userNewId: this.userNewId,
          businessId: this.businessId,
          userCardId: this.beforeUserCardId,
          activeId: this.activeId,
        });
        if (res.data.upgradeStatus !== 1) {
          Toast.show('升级失败');
        }
        this.$emit('update:show', false);
        this.$emit('reload');
      } catch {
        Toast.show('升级失败');
        this.$emit('updateError');
      }
      UBT.clickButton({
        pageId: 'platform_cardupdate_trans',
        buttonName: 'platform_cardupdate_confirm',
        categoryId: 'platform',
        businessInfo: {
          bizType: this.businessId - 1,
        },
      });
    },
    close() {
      this.$emit('update:show', false);
    },
  },
};
</script>

<style lang="less" scoped>
.dialog-container {
  .dialog-info {
    width: 3.2rem;
    height: 4.17rem;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 330;

    .dialog-block {
      width: 3.2rem;
      height: 3.63rem;
      background-image: url(https://m.hellobike.com/resource/helloyun/wb23235/5Y3ofL-yrR.png?x-oss-process=image/quality,q_80);
      background-size: 100% 100%;
      overflow: hidden;

      .dialog-btn {
        background-image: url(https://m.hellobike.com/resource/helloyun/08345/bfK2NxYEje.png?x-oss-process=image/quality,q_80);
        background-size: 100% 100%;
        width: 2.92rem;
        height: 0.77rem;
        margin: 2.65rem auto 0 auto;
      }
    }

    .dialog-close {
      width: 0.38rem;
      height: 0.38rem;
      margin: 0.16rem auto 0 auto;

      img {
        width: 0.38rem;
        height: 0.38rem;
      }
    }
  }

  .shadow {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 300;
  }
}
</style>
